import React from "react";
import { Card } from "primereact/card";
import { Button } from "primereact/button";

interface ErrorStateProps {
  error: string;
  onRetry: () => void;
  title?: string;
}

const ErrorState: React.FC<ErrorStateProps> = ({
  error,
  onRetry,
  title = "Error Loading Data",
}) => {
  return (
    <div style={{ width: "100%", marginTop: "-30px", marginBottom: "-30px" }}>
      <Card className="p-4">
        <div className="text-center">
          <h3>{title}</h3>
          <p className="text-red-600 mb-3">{error}</p>
          <Button
            onClick={onRetry}
            label="Retry"
            icon="pi pi-refresh"
            className="p-button-primary"
          />
        </div>
      </Card>
    </div>
  );
};

export default ErrorState;
